import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { resetPassword } from 'Api/AccountApi';
import { onSubmitReactFormError } from 'Utils/FormValidation';
import { CenterFrameLayout } from 'Layouts';
import ResetPasswordForm from 'Forms/ResetPasswordForm';
import { ConfirmSignIn } from 'Features/ResetPassword/ConfirmSignIn';
import 'Features/ResetPassword/DefaultResetPassword/DefaultResetPassword.css';

export const ResetSignInContainer = (props) => {
  const [signInSuccess, setSignInSuccess] = useState(false);
  const { routes } = useSelector((s) => s.appConfig);

  const requestLogin = (values) => {
    const { newPass } = values;
    const params = new URLSearchParams(props.location.search);
    const email = params.get('email');
    const { token } = props.params;

    return resetPassword(email, newPass, token)
      .then((response) => response.data)
      .then((data) => {
        if (data.success) {
          setSignInSuccess(true);
        } else {
          throw new Error(data.message);
        }
      })
      .catch(() => {
        return onSubmitReactFormError('Reset password fail.');
      });
  };

  if (signInSuccess) {
    return <ConfirmSignIn routes={routes} />;
  }

  return (
    <CenterFrameLayout title="Reset Your Password" showLoader={false}>
      <div className="centerForm">
        <ResetPasswordForm onFormSubmit={requestLogin} {...props} />
      </div>
    </CenterFrameLayout>
  );
};
